import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { canEditPledge } from 'donor-elf-web/lib/pledge-utils';
import PledgeModel from 'donor-elf-web/models/pledge';
import AbilitiesService from 'donor-elf-web/services/abilities';

export default class CanEditPledgeHelper extends Helper {
  @service declare abilities: AbilitiesService;

  compute([pledge]: PledgeModel[] /*namedArgs*/) {
    return canEditPledge(pledge, this.abilities);
  }
}
